import { render, staticRenderFns } from "./OperacionesViewProductos.vue?vue&type=template&id=4ed67272&"
import script from "./OperacionesViewProductos.vue?vue&type=script&lang=js&"
export * from "./OperacionesViewProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports